import { createStateHook } from 'react-sweet-state';
import { store } from '../../main';
export var useError = createStateHook(store, {
  selector: function selector(state) {
    return state.error;
  }
});